import { useEffect, useLayoutEffect, useState } from 'react';
/**
 * Utility hook to let us use an element's measurements before the first client
 * paint
 */
export function useElementRefBeforeFirstPaint(ref) {
    const beforeRender = ref.current;
    const setRerenderState = useState(0)[1];
    const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;
    useIsomorphicLayoutEffect(() => {
        if (beforeRender == null && ref.current) {
            setRerenderState((n) => n + 1);
        }
    }, [beforeRender, ref, setRerenderState]);
}
